import React, { useState } from 'react';
import { AlertTriangle, Send, CheckCircle } from 'lucide-react';
import { api } from '../lib/api';
import Modal from '../components/Modal';

export default function SecurityReport({ notify, navigate }) {
    const [form, setForm] = useState({
        organization: '',
        date_time: new Date().toISOString().slice(0, 16),
        involved_parties: '',
        description: '',
        contact_method: 'email',
        contact_info: ''
    });
    const [busy, setBusy] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    async function save(e) {
        e.preventDefault(); setBusy(true);
        try {
            await api('/security-reports', { method: 'POST', body: form });
            setSubmitted(true);
            notify('Security incident report submitted successfully.');
        } catch (e) { notify(e.message); }
        finally { setBusy(false); }
    }

    if (submitted) return (
        <div className="page-center" style={{ textAlign: 'center', padding: '40px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
                <CheckCircle size={64} color="var(--primary-color)" />
                <h2>Report Submitted</h2>
                <p>Thank you for reporting this incident. Our security team has been notified and will investigate immediately.</p>
                <button className="button primary" onClick={() => navigate('/facility')}>Return to Workspace</button>
            </div>
        </div>
    );

    return (
        <section className="content-card" style={{ maxWidth: '800px', margin: '0 auto' }}>
            <div className="content-heading">
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <AlertTriangle size={24} color="var(--danger-color)" />
                    <div>
                        <h3 style={{ margin: 0 }}>Report a Security Incident</h3>
                        <p style={{ margin: 0, fontSize: 13, color: 'var(--text-secondary)' }}>
                            Report suspected unauthorized access, loss of device, malware, or inappropriate record viewing.
                        </p>
                    </div>
                </div>
            </div>

            <form className="admin-form" onSubmit={save}>
                <div className="form-grid">
                    <label>Organization/Facility<input required value={form.organization} onChange={e => setForm({ ...form, organization: e.target.value })} placeholder="Clinic or Facility name"/></label>
                    <label>Date & Time of Incident<input type="datetime-local" required value={form.date_time} onChange={e => setForm({ ...form, date_time: e.target.value })}/></label>
                </div>

                <label>Involved Parties<textarea rows={2} value={form.involved_parties} onChange={e => setForm({ ...form, involved_parties: e.target.value })} placeholder="Names of people or specific patient records involved"/></label>
                <label>Description of Incident<textarea required rows={6} value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} placeholder="Please describe what occurred in detail..."/></label>

                <div className="form-grid" style={{ marginTop: 20 }}>
                    <label>Preferred Contact Method
                        <select value={form.contact_method} onChange={e => setForm({ ...form, contact_method: e.target.value })}>
                            <option value="email">Email</option>
                            <option value="phone">Phone</option>
                            <option value="secure-message">Secure Message</option>
                        </select>
                    </label>
                    <label>Contact Information<input required value={form.contact_info} onChange={e => setForm({ ...form, contact_info: e.target.value })} placeholder="Email address or phone number"/></label>
                </div>

                <div style={{ marginTop: 24, padding: 16, backgroundColor: 'var(--bg-secondary)', borderRadius: 8, border: '1px solid var(--border-color)', fontSize: 13, color: 'var(--text-secondary)' }}>
                    <strong style={{ display: 'block', marginBottom: 8 }}>Important Notice:</strong>
                    <p style={{ margin: 0 }}>This report is sent directly to the Bridge Technologies Security Team. Please ensure you are following your organization's internal breach reporting policies in addition to this report.</p>
                </div>

                <button className="button primary" disabled={busy} style={{ marginTop: 24 }}>
                    {busy ? 'Submitting...' : 'Submit Incident Report'}
                </button>
            </form>
        </section>
    );
}
